import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, Formik, Form, ErrorMessage, FieldArray } from 'formik';
import * as actions from './redux/actions';
import * as collections from '../collections/redux/actions';
import * as home from '../home/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { promptRolesValidationSchema } from './utils';
import CustomLoader from '../common/CustomLoader';
import { toast } from 'react-toastify';
import LoadingCard from './LoadingCard';

export class PromptRolesList extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.onbeforeunload = (event) => {
      const message = 'If you reload this page, data will be lost. Are you sure?';
      event.returnValue = message;
      return message;
    };
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  handleSubmit = async (values) => {
    try {
      const { actions, match, history, location } = this.props;
      const { state = {} } = location;
      const { userPrompt } = state;
      const { version, projectId } = match.params;
      const roleResponse = await actions.addRolesAndUsers({ projectId, version, values });
      if (!roleResponse) {
        toast.error('Failed to add roles and users');
        return;
      }

      if (roleResponse && roleResponse.data && roleResponse.data.success === true) {
        toast.success(roleResponse.message);
        history.push({
          pathname: `/ai-prompt-builder/${version}/v/${projectId}/generate-layouts`,
          state: { userPrompt, roles: values.roles },
        });
      } else if (roleResponse && roleResponse.data && roleResponse.data.success === false) {
        toast.error(roleResponse.data.message);
      } else {
        toast.error('Failed to create roles for the application');
      }
    } catch (error) {
      console.error('handleSubmit Error:', error);
      toast.error('An unexpected error occurred while creating role for the application');
    }
  };

  render() {
    const { location, aiPromptBuilder } = this.props;
    const { state = {} } = location;
    const { rolesData = [], systemRoles = [] } = state;
    const { addRolesAndUsersPending, createAppPending } = aiPromptBuilder;
    const loadingF = addRolesAndUsersPending || createAppPending;
    if (loadingF) {
      return (
        <LoadingCard
          headerText="Creating Roles & Users for Your Application"
          loadingText="Please wait while we are generating roles & users for your application..."
          loadingFlag={loadingF}
          headerIcon="aiModelConfig"
        />
      );
    }
    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <Formik
              enableReinitialize
              initialValues={{
                roles: rolesData.map((r) => r.displayName || ''),
              }}
              validationSchema={promptRolesValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {({ values, submitForm, isSubmitting }) => (
                <>
                  <ParentContentCard
                    title="AI Suggested Roles For Your Application"
                    icon="aiModelConfig"
                  >
                    <div className="center-div">
                      <div className="container ml-5 mb-4">
                        <h5 style={{ textTransform: 'none' }}>
                          The following roles have been generated based on your application. You can
                          review and modify them below.
                        </h5>
                        <h5 className="mb-4" style={{ textTransform: 'none' }}>
                          These roles are automatically created based on your application setup. You
                          can add or remove roles as needed, and modify the names of the roles to
                          better fit your requirements.
                        </h5>
                        <h5 className="mb-4" style={{ textTransform: 'none' }}>
                          <strong>Note:</strong> <u>Super Admin</u> and <u>Tenant Admin</u> roles
                          are
                          <strong> system-defined</strong> and have been generated already —
                          <strong>do not create them manually</strong>.
                        </h5>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="w-75">
                        <Form>
                          {(systemRoles || []).map((el) => {
                            return (
                              <div key={el.uuid} className="form-row mb-2">
                                <div className="col-sm-10">
                                  <Field
                                    type="text"
                                    name="system"
                                    className="form-control form-control-sm"
                                    placeholder="Role Name"
                                    value={el.name}
                                    disabled={true}
                                  />
                                </div>
                                <div className="">
                                  <i
                                    className="wb webconnect-check-circle"
                                    style={{
                                      color: '#93a828',
                                      fontSize: '1.1rem',
                                      marginLeft: '8px',
                                    }}
                                    title="System Default"
                                  ></i>
                                </div>
                              </div>
                            );
                          })}
                          <FieldArray name="roles">
                            {({ push, remove }) => (
                              <>
                                {values.roles.map((role, index) => (
                                  <div key={index} className="form-row mb-2">
                                    <div className="col-sm-10">
                                      <Field
                                        type="text"
                                        name={`roles[${index}]`}
                                        className="form-control form-control-sm"
                                        placeholder="Role Name"
                                      />
                                      <ErrorMessage
                                        name={`roles[${index}]`}
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>

                                    <div className="col-sm-2">
                                      <button
                                        className="btn btn-xs btn-theme-delete btn-icon-only"
                                        type="button"
                                        onClick={() => remove(index)}
                                      >
                                        <i className="wb webconnect-times"></i>
                                      </button>
                                    </div>
                                  </div>
                                ))}

                                <div className="d-flex justify-content-end m-4 mt-5">
                                  <button
                                    type="button"
                                    className="btn btn-theme-submit btn-sm"
                                    onClick={() => push('')}
                                  >
                                    <i className="wb webconnect-plus"></i> Add Role
                                  </button>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </Form>
                      </div>
                    </div>
                  </ParentContentCard>
                  <div className="d-flex justify-content-end mr-4">
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      onClick={submitForm}
                      title="Save & Go to Next Step"
                      disabled={isSubmitting || addRolesAndUsersPending || createAppPending}
                    >
                      <i className="wb webconnect-save-regular"></i>&nbsp;Create Roles & Continue
                      <CustomLoader
                        loading={isSubmitting || addRolesAndUsersPending || createAppPending}
                      />
                    </button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    collections: state.collections,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    collections: bindActionCreators({ ...collections }, dispatch),
    home: bindActionCreators({ ...home }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PromptRolesList);
